

// ==================== Featured Playlists ====================
export const featuredPlaylists = [
  {
    id: 1,
    title: "Today's Top Hits",
    description: "The most played songs right now",
    trackCount: 50,
    imageUrl:
      "https://readdy.ai/api/search-image?query=vibrant%20music%20playlist%20cover%20with%20modern%20geometric%20patterns%2C%20purple%20and%20pink%20gradients%2C%20contemporary%20digital%20art%20style%2C%20energetic%20and%20dynamic%20composition&width=300&height=300&seq=playlist-1&orientation=squarish",
    plays: "2.1M",
    tracks: [
      {
        id: 101,
        title: "Midnight Dreams",
        artist: "Luna Eclipse",
        duration: "3:45",
        genre: "Pop",
        mood: "Chill",
        plays: 1_250_000
      },
      {
        id: 102,
        title: "Electric Pulse",
        artist: "Neon Waves",
        duration: "4:12",
        genre: "Electronic",
        mood: "Energetic",
        plays: 890_000
      }
    ]
  },
  {
    id: 2,
    title: "Chill Vibes",
    description: "Relaxing beats for your day",
    trackCount: 35,
    imageUrl:
      "https://readdy.ai/api/search-image?query=calm%20and%20peaceful%20music%20playlist%20cover%20with%20soft%20blue%20and%20purple%20tones%2C%20minimalist%20design%2C%20serene%20abstract%20patterns%2C%20relaxing%20atmosphere&width=300&height=300&seq=playlist-2&orientation=squarish",
    plays: "1.8M",
    tracks: [
      {
        id: 201,
        title: "Ocean Breeze",
        artist: "Coastal Dreams",
        duration: "3:33",
        genre: "Chill",
        mood: "Chill",
        plays: 980_000
      },
      {
        id: 202,
        title: "Starlight Serenade",
        artist: "Midnight Jazz",
        duration: "5:22",
        genre: "Jazz",
        mood: "Romantic",
        plays: 650_000
      }
    ]
  },
  {
    id: 3,
    title: "Electronic Dreams",
    description: "Future sounds and synth waves",
    trackCount: 42,
    imageUrl:
      "https://readdy.ai/api/search-image?query=futuristic%20electronic%20music%20cover%20with%20neon%20colors%2C%20cyberpunk%20aesthetic%2C%20digital%20glitch%20effects%2C%20purple%20and%20cyan%20color%20scheme&width=300&height=300&seq=playlist-3&orientation=squarish",
    plays: "950K",
    tracks: [
      {
        id: 301,
        title: "Digital Love",
        artist: "Cyber Hearts",
        duration: "3:41",
        genre: "Electronic",
        mood: "Romantic",
        plays: 1_320_000
      },
      {
        id: 302,
        title: "Neon Nights",
        artist: "Retro Future",
        duration: "3:52",
        genre: "Pop",
        mood: "Party",
        plays: 1_890_000
      }
    ]
  },
  {
    id: 4,
    title: "Indie Discoveries",
    description: "Fresh indie tracks you'll love",
    trackCount: 28,
    imageUrl:
      "https://readdy.ai/api/search-image?query=indie%20music%20album%20cover%20with%20vintage%20aesthetic%2C%20warm%20earth%20tones%2C%20artistic%20illustration%20style%2C%20creative%20and%20authentic%20design&width=300&height=300&seq=playlist-4&orientation=squarish",
    plays: "720K",
    tracks: [
      {
        id: 401,
        title: "Golden Hour",
        artist: "Sunset Boulevard",
        duration: "3:28",
        genre: "Indie",
        mood: "Happy",
        plays: 2_100_000
      },
      {
        id: 402,
        title: "Mountain High",
        artist: "Alpine Echo",
        duration: "4:07",
        genre: "Country",
        mood: "Happy",
        plays: 780_000
      }
    ]
  },
  {
    id: 5,
    title: "Workout Energy",
    description: "High-energy tracks for your fitness",
    trackCount: 38,
    imageUrl:
      "https://readdy.ai/api/search-image?query=energetic%20workout%20music%20cover%20with%20bold%20red%20and%20orange%20gradients%2C%20dynamic%20motion%20graphics%2C%20powerful%20and%20motivating%20design&width=300&height=300&seq=playlist-5&orientation=squarish",
    plays: "1.2M",
    tracks: [
      {
        id: 501,
        title: "Workout Anthem",
        artist: "Fitness Beats",
        duration: "3:58",
        genre: "Electronic",
        mood: "Workout",
        plays: 2_250_000
      },
      {
        id: 502,
        title: "Thunder Road",
        artist: "Storm Riders",
        duration: "4:55",
        genre: "Rock",
        mood: "Energetic",
        plays: 1_750_000
      }
    ]
  },
  {
    id: 6,
    title: "Jazz Classics",
    description: "Timeless jazz masterpieces",
    trackCount: 45,
    imageUrl:
      "https://readdy.ai/api/search-image?query=classic%20jazz%20music%20cover%20with%20elegant%20gold%20and%20black%20design%2C%20vintage%20saxophone%20silhouette%2C%20sophisticated%20and%20timeless%20aesthetic&width=300&height=300&seq=playlist-6&orientation=squarish",
    plays: "680K",
    tracks: [
      {
        id: 601,
        title: "Smooth Operator",
        artist: "Jazz Collective",
        duration: "4:44",
        genre: "Jazz",
        mood: "Chill",
        plays: 720_000
      },
      {
        id: 602,
        title: "City Lights",
        artist: "Urban Pulse",
        duration: "3:18",
        genre: "Hip Hop",
        mood: "Energetic",
        plays: 1_450_000
      }
    ]
  }
];

// ==================== Trending Tracks ====================
export const trendingTracks = [
  {
    id: 1,
    title: "Midnight Dreams",
    artist: "Luna Eclipse",
    album: "Nocturnal",
    duration: "3:45",
    plays: "2.3M",
    imageUrl:
      "https://readdy.ai/api/search-image?query=dreamy%20nighttime%20music%20album%20cover%20with%20purple%20and%20blue%20gradients%2C%20moon%20and%20stars%20imagery%2C%20ethereal%20and%20mystical%20atmosphere&width=200&height=200&seq=track-1&orientation=squarish",
    isLiked: false
  },
  {
    id: 2,
    title: "Electric Pulse",
    artist: "Neon Riders",
    album: "Synthwave City",
    duration: "4:12",
    plays: "1.9M",
    imageUrl:
      "https://readdy.ai/api/search-image?query=electric%20synthwave%20music%20cover%20with%20neon%20pink%20and%20cyan%20colors%2C%20retro%20futuristic%20design%2C%20grid%20patterns%20and%20geometric%20shapes&width=200&height=200&seq=track-2&orientation=squarish",
    isLiked: true
  },
  {
    id: 3,
    title: "Ocean Waves",
    artist: "Coastal Breeze",
    album: "Serenity",
    duration: "5:23",
    plays: "1.5M",
    imageUrl:
      "https://readdy.ai/api/search-image?query=peaceful%20ocean%20music%20cover%20with%20soft%20blue%20and%20turquoise%20tones%2C%20gentle%20wave%20patterns%2C%20calming%20and%20serene%20design&width=200&height=200&seq=track-3&orientation=squarish",
    isLiked: false
  },
  {
    id: 4,
    title: "Urban Nights",
    artist: "City Lights",
    album: "Metropolitan",
    duration: "3:58",
    plays: "2.1M",
    imageUrl:
      "https://readdy.ai/api/search-image?query=urban%20nightlife%20music%20cover%20with%20city%20skyline%20silhouette%2C%20purple%20and%20orange%20neon%20lights%2C%20modern%20metropolitan%20atmosphere&width=200&height=200&seq=track-4&orientation=squarish",
    isLiked: true
  },
  {
    id: 5,
    title: "Forest Whispers",
    artist: "Nature's Call",
    album: "Wilderness",
    duration: "4:35",
    plays: "890K",
    imageUrl:
      "https://readdy.ai/api/search-image?query=nature%20music%20cover%20with%20forest%20green%20tones%2C%20tree%20silhouettes%2C%20organic%20patterns%2C%20peaceful%20and%20natural%20atmosphere&width=200&height=200&seq=track-5&orientation=squarish",
    isLiked: false
  }
];

// ==================== Recommended Artists ====================
export const recommendedArtists = [
  {
    id: 1,
    name: "Luna Eclipse",
    genre: "Electronic",
    followers: "1.2M",
    imageUrl:
      "https://readdy.ai/api/search-image?query=electronic%20music%20artist%20portrait%20with%20purple%20and%20pink%20lighting%2C%20futuristic%20aesthetic%2C%20professional%20music%20photography%20style&width=200&height=200&seq=artist-1&orientation=squarish",
    isFollowing: false
  },
  {
    id: 2,
    name: "Neon Riders",
    genre: "Synthwave",
    followers: "850K",
    imageUrl:
      "https://readdy.ai/api/search-image?query=synthwave%20music%20duo%20with%20neon%20lighting%2C%20retro%20futuristic%20style%2C%20cyberpunk%20aesthetic%2C%20professional%20band%20photography&width=200&height=200&seq=artist-2&orientation=squarish",
    isFollowing: true
  },
  {
    id: 3,
    name: "Coastal Breeze",
    genre: "Ambient",
    followers: "620K",
    imageUrl:
      "https://readdy.ai/api/search-image?query=ambient%20music%20artist%20with%20soft%20natural%20lighting%2C%20peaceful%20expression%2C%20minimalist%20photography%20style%2C%20calming%20atmosphere&width=200&height=200&seq=artist-3&orientation=squarish",
    isFollowing: false
  },
  {
    id: 4,
    name: "City Lights",
    genre: "Hip Hop",
    followers: "2.1M",
    imageUrl:
      "https://readdy.ai/api/search-image?query=hip%20hop%20artist%20portrait%20with%20urban%20background%2C%20confident%20pose%20&width=200&height=200&seq=artist-4&orientation=squarish",
    isFollowing: true
  }
];

// ==================== Recently Played ====================
export const recentlyPlayed = [
  {
    id: 1,
    title: "Starlight Journey",
    artist: "Cosmic Wanderer",
    imageUrl:
      "https://readdy.ai/api/search-image?query=space%20music%20album%20cover%20with%20starry%20night%20sky%2C%20cosmic%20colors%2C%20purple%20and%20blue%20nebula%20patterns%2C%20celestial%20atmosphere&width=150&height=150&seq=recent-1&orientation=squarish",
    playedAt: "2 hours ago"
  },
  {
    id: 2,
    title: "Summer Breeze",
    artist: "Sunny Days",
    imageUrl:
      "https://readdy.ai/api/search-image?query=summer%20music%20cover%20with%20warm%20yellow%20and%20orange%20tones%2C%20sunny%20atmosphere%2C%20bright%20and%20cheerful%20design&width=150&height=150&seq=recent-2&orientation=squarish",
    playedAt: "5 hours ago"
  },
  {
    id: 3,
    title: "Digital Dreams",
    artist: "Tech Noir",
    imageUrl:
      "https://readdy.ai/api/search-image?query=digital%20music%20cover%20with%20glitch%20effects%2C%20matrix-style%20green%20and%20black%20colors%2C%20futuristic%20technology%20theme&width=150&height=150&seq=recent-3&orientation=squarish",
    playedAt: "1 day ago"
  },
  {
    id: 4,
    title: "Mountain Echo",
    artist: "Alpine Sound",
    imageUrl:
      "https://readdy.ai/api/search-image?query=mountain%20music%20cover%20with%20majestic%20peaks%2C%20natural%20earth%20tones%2C%20outdoor%20adventure%20atmosphere&width=150&height=150&seq=recent-4&orientation=squarish",
    playedAt: "2 days ago"
  }
];

// ==================== Music Data ====================
export const musicData = {
  tracks: [
    {
      id: 1,
      title: "Midnight Dreams",
      artist: "Luna Eclipse",
      duration: "3:45",
      genre: "Pop",
      mood: "Chill",
      plays: 1_250_000
    },
    {
      id: 2,
      title: "Electric Pulse",
      artist: "Neon Waves",
      duration: "4:12",
      genre: "Electronic",
      mood: "Energetic",
      plays: 890_000
    },
    {
      id: 3,
      title: "Golden Hour",
      artist: "Sunset Boulevard",
      duration: "3:28",
      genre: "Indie",
      mood: "Happy",
      plays: 2_100_000
    },
    {
      id: 4,
      title: "Thunder Road",
      artist: "Storm Riders",
      duration: "4:55",
      genre: "Rock",
      mood: "Energetic",
      plays: 1_750_000
    },
    {
      id: 5,
      title: "Ocean Breeze",
      artist: "Coastal Dreams",
      duration: "3:33",
      genre: "Chill",
      mood: "Chill",
      plays: 980_000
    },
    {
      id: 6,
      title: "City Lights",
      artist: "Urban Pulse",
      duration: "3:18",
      genre: "Hip Hop",
      mood: "Energetic",
      plays: 1_450_000
    },
    {
      id: 7,
      title: "Starlight Serenade",
      artist: "Midnight Jazz",
      duration: "5:22",
      genre: "Jazz",
      mood: "Romantic",
      plays: 650_000
    },
    {
      id: 8,
      title: "Digital Love",
      artist: "Cyber Hearts",
      duration: "3:41",
      genre: "Electronic",
      mood: "Romantic",
      plays: 1_320_000
    },
    {
      id: 9,
      title: "Mountain High",
      artist: "Alpine Echo",
      duration: "4:07",
      genre: "Country",
      mood: "Happy",
      plays: 780_000
    },
    {
      id: 10,
      title: "Neon Nights",
      artist: "Retro Future",
      duration: "3:52",
      genre: "Pop",
      mood: "Party",
      plays: 1_890_000
    },
    {
      id: 11,
      title: "Silent Storm",
      artist: "Echo Chamber",
      duration: "4:33",
      genre: "Rock",
      mood: "Sad",
      plays: 1_100_000
    },
    {
      id: 12,
      title: "Sunrise Melody",
      artist: "Dawn Chorus",
      duration: "3:15",
      genre: "Classical",
      mood: "Focus",
      plays: 540_000
    },
    {
      id: 13,
      title: "Workout Anthem",
      artist: "Fitness Beats",
      duration: "3:58",
      genre: "Electronic",
      mood: "Workout",
      plays: 2_250_000
    },
    {
      id: 14,
      title: "Smooth Operator",
      artist: "Jazz Collective",
      duration: "4:44",
      genre: "Jazz",
      mood: "Chill",
      plays: 720_000
    },
    {
      id: 15,
      title: "Heartbreak Hotel",
      artist: "Emotional Waves",
      duration: "3:29",
      genre: "R&B",
      mood: "Sad",
      plays: 1_680_000
    }
  ]
};

